module.exports = __webpack_public_path__ + "img/registro-aside.ce45d4ae.svg";